const AVAILABLE_ENVIRONMENTS = ['development', 'production'];
export default AVAILABLE_ENVIRONMENTS;